"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toArray_1 = require("../jsUtils/toArray");
/**
 * @deprecated
 * Creates an HTML node array from html
 * @param html the html string to create HTML elements from
 * @param ownerDocument Owner document of the result HTML elements
 * @returns An HTML node array to represent the given html string
 */
function fromHtml(html, ownerDocument) {
    var element = ownerDocument.createElement('DIV');
    element.innerHTML = html;
    return (0, toArray_1.default)(element.childNodes);
}
exports.default = fromHtml;
//# sourceMappingURL=fromHtml.js.map